var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { SearchOutlined } from '@ant-design/icons';
export function Button(_a) {
    var { children = 'Buscar', className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement("button", Object.assign({ className: clsx("!bg-[#ff7020] w-[148px] justify-center !text-black rounded-lg flex items-center disabled:bg-gray h-[64px] sm:self-end lg:self-center", className) }, props),
        children,
        " ",
        React.createElement(SearchOutlined, { className: "ml-2" })));
}
//# sourceMappingURL=index.js.map